﻿import { IInputScope, KbInput } from "@app/components/kb-input/kb-input.component";
import { NgComponent } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { Dirs } from "@app/helpers/dirs";
import { eMaskType } from "@models";
import { Utils } from "@tools";

export interface ITextboxScope extends IInputScope {
    mask?: string; // 
    _maskConfig?: {};
}

@NgComponent({
    token: Token.KbTextbox,
    dependencies: [
        Token.$Timeout
    ]
})
export class KbTextbox extends KbInput {
    constructor($timeout: ng.ITimeoutService) {
        super($timeout);
        this.scope = Utils.extend(this.scope, {
            mask: "=?"
        });
        this.template = Dirs.component("kb-textbox");
        this.controller = [
            "$scope",
            "$element",
            "$attrs",
            function (
                $scope: ITextboxScope,
                $element: ng.IAugmentedJQuery,
                $attrs: ng.IAttributes) {
            
                $scope._maskConfig = {
                    mask: () => {
                        switch ($scope.mask) {
                            case eMaskType.phone:
                                return ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
                            case eMaskType.zipCode:
                                return [/\d/, /\d/, /\d/, /\d/, /\d/];
                            default:
                                return false;
                        }
                    },
                    placeholderChar: '\u2000',
                    guide: true,
                    keepCharPositions: false,
                    showMask: false
                };
        }];
        this.link = (scope: ITextboxScope, element: ng.IAugmentedJQuery, atts: ng.IAttributes, controllers: any[]) => {
            this.kbInputLinkFn(scope, element, atts, controllers);

            //need to fully blur field on ESC press
            element.on("keydown", (e: JQuery.Event) => {
                if (e.key == 'Escape') {
                    element.find("input").trigger('blur');
                    element.find("textarea").trigger('blur');
                }
            });
        };
    }
}
